import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material';
import Header from 'components/Header';
import './default.css';
type LayoutProps = {
  children?: JSX.Element | JSX.Element[];
};

let outerTheme = createTheme({
  palette: {
    primary: {
      main: '#1565c0',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#3D548F',
      contrastText: '#fff',
    },
    text: {
      primary: '#222E50',
    },
  },
  typography: {
    htmlFontSize: 6,
    fontSize: 6,
    button: {
      textTransform: 'none',
    },
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 500,
    },
  },
});
outerTheme = responsiveFontSizes(outerTheme);

const DefaultLayout = ({ children }: LayoutProps) => {
  return (
    <div className="DefaultLayout">
      <ThemeProvider theme={outerTheme}>
        <Header />
        <div className="container">{children}</div>
      </ThemeProvider>
    </div>
  );
};
export default DefaultLayout;
